import Paragraph from "../components/paragraph/Paragraph";

const NonAuthedBanner = () => {
  return (
    <div className="auth-banner">
      <div className="auth-banner_banner">
        <h1>
          Tvoj korak ka boljem životu{" "}
          <span className="auth-banner_title-end">kreće odavde.</span>
        </h1>
        <Paragraph variant="p2" className="auth-banner_body">
          <span className="auth-banner_lead">
            Ti znaš šta želiš da promeniš ali ti nedostaju jasni koraci da tu promenu kreiraš u životu.
          </span>
          <br />
          <br />
          <span className="u-color-secondary-500">NeoUm platforma</span>{" "} je namenjena tebi da bolje razumeš sebe i naučiš
          kako promena zaista nastaje na nivou nervnog sistema. Kroz praktična
          znanja iz neurobiologije, psihologije i duhovnosti,{" "}
          <span className="u-color-secondary-500">
            dobijaš jasne protokole i konkretne korake
          </span>{" "}
          koji ti mogu pomoći da <span className="u-color-secondary-500">izgradiš svesniji, stabilniji i ispunjeniji
          život.</span>{" "}
          <br />
          <br />
          Nije ti potrebno prethodno znanje. Dovoljni su radoznalost i spremnost
          da ono što naučiš primeniš u svom životu.
        </Paragraph>
      </div>
    </div>
  );
};

export default NonAuthedBanner;
